import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler
);

const TemperatureChart = ({ hourlyData, selectedDate }) => {
  // Filter data for the selected date
  const filteredData = hourlyData.filter((item) => {
    const itemDate = new Date(item.dt * 1000).toLocaleDateString();
    const selectedDateStr = selectedDate.toLocaleDateString();
    return itemDate === selectedDateStr;
  });

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: `Temperatures for ${selectedDate.toLocaleDateString()}`,
        align: "start",
        font: {
          size: 16,
          weight: "normal",
        },
        padding: {
          bottom: 30,
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          maxRotation: 0,
          maxTicksLimit: 6,
          callback: (value) => {
            const time = new Date(
              filteredData[value].dt * 1000
            ).toLocaleTimeString("en-US", {
              hour: "numeric",
              hour12: true,
            });
            return time;
          },
        },
      },
      y: {
        position: "right",
        grid: {
          color: "rgba(0, 0, 0, 0.1)",
        },
        ticks: {
          callback: (value) => `${value}°`,
        },
      },
    },
  };

  const data = {
    labels: filteredData.map((item) =>
      new Date(item.dt * 1000).toLocaleTimeString("en-US", { hour: "2-digit" })
    ),
    datasets: [
      {
        fill: true,
        data: filteredData.map((item) => Math.round(item.main.temp)),
        borderColor: "rgb(255, 107, 107)",
        backgroundColor: "rgba(255, 107, 107, 0.2)",
        tension: 0.4,
        pointRadius: 0,
      },
    ],
  };

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div className="h-64">
        <Line options={options} data={data} />
      </div>
    </div>
  );
};

export default TemperatureChart;
